<div class="miscellaneousItemTitle">
  <h1> Redeployment Boxes and Labels </h1>
</div>

@if(entity){

<div class="miscellaneousItem-section">
  @for(miscellaneousItem of entity.data; track miscellaneousItem){
  <div>
    <kendo-card class="miscellaneousItemCard">
      <kendo-card-header class="miscellaneousItemHeader">
        {{miscellaneousItem.name}}
      </kendo-card-header>
      <kendo-card-body>
        <div style="padding: 0px 10px;">
          <br />
          <div id="miscellaneousItemContainer">
            <div class="miscellaneousItem-item"
                 (click)="checkoutMiscellaneousItem(miscellaneousItem.id)"
                 style="background-image: url({{miscellaneousItem.miscellaneousItemImage}}); background-size: contain; background-repeat: no-repeat; background-position: center; ">
            </div>
          </div>
        </div>
      </kendo-card-body>
      <kendo-card-footer style=" color: white; background-color: #08408b; opacity: 85%;">
        <button kendoButton class="viewBtn" (click)="checkoutMiscellaneousItem(miscellaneousItem.id)" title="VIEW">VIEW</button>
      </kendo-card-footer>
    </kendo-card>
  </div>
  }
</div>

}
